var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 17.4c.8.8 2 .8 2.8 0 .8-.8.8-2 0-2.8L12.8 10l4.6-4.6c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0L10 7.2 5.4 2.6c-.8-.8-2-.8-2.8 0s-.8 2 0 2.8L7.2 10l-4.6 4.6c-.8.8-.8 2 0 2.8.8.8 2 .8 2.8 0l4.6-4.6 4.6 4.6z"
  })));
};
export default SvgClose;